import { gql } from '@apollo/client';

export const DAILY_TIPS_STATS_QUERY = gql`
  query DailyTipsStats($periodType: String = "last_90_days") {
    dailyTipsStats(periodType: $periodType) {
      period_type
      total_tips
      settled_tips
      winning_tips
      losing_tips
      total_units_staked
      total_profit_loss
      roi_percentage
      strike_rate_percentage
      avg_winner_odds
      best_winner_odds
      longest_winning_streak
      longest_losing_streak
      current_streak
      current_streak_type
      last_calculated_at
    }
  }
`;

export const ALL_DAILY_TIPS_STATS_QUERY = gql`
  query DailyTipsStatsAll {
    dailyTipsStatsAll {
      period_type
      total_tips
      settled_tips
      winning_tips
      losing_tips
      total_units_staked
      total_profit_loss
      roi_percentage
      strike_rate_percentage
      avg_winner_odds
      best_winner_odds
      longest_winning_streak
      longest_losing_streak
      current_streak
      current_streak_type
      last_calculated_at
    }
  }
`;
